// src/components/Modals/RolePlayPublishedModal.js
import React, { useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { X } from "lucide-react";

const RolePlayPublishedModal = ({ show, onHide, delay = 7000 }) => {

    // Auto-close logic
    useEffect(() => {
        let timer;
        if (show) {
            timer = setTimeout(() => {
                onHide(); // Close modal after delay
            }, delay);
        }
        // Cleanup timer if component unmounts or user closes manually
        return () => clearTimeout(timer);
    }, [show, onHide, delay]);

    return (
        <Modal
            show={show}
            onHide={() => onHide(false)}
            centered
            style={{
                borderRadius: "16px",
                padding: "24px"
            }}
        >
            <Modal.Body className="text-center" style={{
                display: "flex", flexDirection: "column", gap: "16px", padding: "24px", position: "relative"
            }}>
                {/* Close Button  */}
                <X
                    className="position-absolute"
                    size={24}
                    color="#6B7280"
                    style={{ top: '15px', right: '15px', cursor: 'pointer' }}
                    onClick={() => onHide(false)}
                />

                {/* Success Image  */}
                <div className="d-flex justify-content-center mt-3">
                    <img
                        style={{ width: "5rem" }}
                        src={`${process.env.PUBLIC_URL}/img/tick.png`}
                        alt="Success Tick"
                    />
                </div>

                {/* Title */}
                <h4 className="font-clash-display" style={{
                    fontSize: "30px", lineHeight: "36px", color: "#1F2937", margin: 0
                }}>
                    Roleplay Published
                </h4>

                {/* Subtext */}
                <p style={{
                    fontFamily: "Plus Jakarta Sans",
                    fontWeight: "500",
                    fontSize: "16px",
                    lineHeight: "24px",
                    color: "#1F2937",
                    marginBottom: "8px"
                }}>
                    “Your role play has been successfully published.”<br />
                    Automatically added to: <strong>"My role plays"</strong>.<br />
                    Immediately available to start via 🎯 PractAIce
                </p>

                {/* Divider Line */}
                <div style={{ borderBottom: "1px solid #D1D5DB", width: "100%" }}></div>

                {/* Footer Note */}
                {/* <div style={{ display: "flex", justifyContent: "center", paddingTop: "8px" }}>
                    <p style={{ fontSize: "14px", color: "#6B7280", margin: 0 }}>
                        “You can always edit this role play later via ✏️ Edit.”
                    </p>
                </div> */}
            </Modal.Body>
        </Modal>
    );
};

export default RolePlayPublishedModal;